import React from 'react';
import {Linking, Modal, TouchableWithoutFeedback} from 'react-native';

import {Button} from '../../Interface/Forms/Buttons/Button';
import {LinkButton} from '../../Interface/Forms/Buttons/LinkButton';

import {Actions, BodyText, Card, LinkItemContainer, Overlay, Title} from './styles';

type EmprestimoTermsModalProps = {
  visible: boolean;
  onAccept: () => void;
  onClose: () => void;
};

export function EmprestimoTermsModal({
  visible,
  onAccept,
  onClose,
}: EmprestimoTermsModalProps) {
  return (
    <Modal
      transparent
      animationType="fade"
      visible={visible}
      onRequestClose={onClose}>
      <Overlay activeOpacity={1} onPress={onClose}>
        <TouchableWithoutFeedback>
          <Card>

            <Title>Termos e condições de uso</Title>
            <BodyText>
              Para acessar a área de Empréstimo, você precisa concordar com os
              termos de uso. Ao continuar, você confirma que leu e aceita essas
              condições.
            </BodyText>
            <LinkItemContainer>
              <LinkButton
                text="Ler termos e condições de uso"
                action={() => Linking.openURL('https://barataocombustiveis.com.br/termos-e-condicoes-emprestimo')}
                enabled
              />
            </LinkItemContainer>
            <Actions>
              <Button
                title="Concordo e continuar"
                enabled
                onPress={onAccept}
              />

            </Actions>
          </Card>
        </TouchableWithoutFeedback>
      </Overlay>
    </Modal>
  );
}
